import React, { forwardRef } from 'react'
import { tv } from 'tailwind-variants'

// In the manner of shadcn/ui's input: 36px tall, 13px text, 12px in from an 8px-rounded quiet border
// that darkens on hover, and a blue border and soft ring while focused. In the dark theme it's a faint
// lift above the surface rather than a hole in it. data-slot takes it out
// of style.scss's rules for bare inputs, so these classes (and a caller's own) apply; the font,
// weight and sizing those rules gave it are set here instead.
/** The text field's look, for a control that can't be an Input (a multi-line field). */
export const input = tv({
  base: [
    'block box-border w-full h-9 px-3 py-0 rounded-lg border border-divider bg-field',
    '[font-family:inherit] text-[13px] font-normal leading-5 text-body placeholder:text-faint',
    'transition-[border-color,box-shadow] duration-150 outline-none',
    'hover:border-faint focus:border-blue focus:ring-3 focus:ring-blue/15',
    'aria-invalid:border-red aria-invalid:focus:ring-red/15',
    'disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:hover:border-divider',
    'read-only:cursor-default'
  ]
})

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => {
  return <input ref={ref} data-slot="input" className={input({ class: className })} {...props} />
})

Input.displayName = 'Input'

export default Input
